(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  // Wires the play/pause button and circular progress ring for each hero-banner
  // video. Safe to call multiple times; each button is guarded by data-init
  // so we don't bind twice in the theme editor.
  (function () {
    var TAU = 2 * Math.PI;

    function initSection(section) {
      if (!section || !section.querySelectorAll) return;

      var buttons = section.querySelectorAll('.hero-banner__play-control[data-hero-banner-play]');
      buttons.forEach(function (button) {
        if (button.dataset.heroBannerInit === '1') return;
        button.dataset.heroBannerInit = '1';

        var hero = button.closest('.hero-banner');
        if (!hero) return;
        var videos = hero.querySelectorAll('video.hero-banner__video');
        if (!videos.length) return;

        function activeVideo() {
          for (var i = 0; i < videos.length; i++) {
            if (videos[i].offsetParent !== null) return videos[i];
          }
          return videos[0];
        }

        var progressEl = button.querySelector('[data-hero-banner-play-progress]');
        var radius = progressEl ? parseFloat(progressEl.getAttribute('r')) : 29;
        var circumference = TAU * radius;

        if (progressEl) {
          progressEl.style.strokeDasharray = circumference;
          progressEl.style.strokeDashoffset = circumference;
        }

        var rafId = 0;

        function setProgress(fraction) {
          if (!progressEl) return;
          if (!isFinite(fraction) || fraction < 0) fraction = 0;
          if (fraction > 1) fraction = 1;
          progressEl.style.strokeDashoffset = circumference * (1 - fraction);
        }

        function tick() {
          var video = activeVideo();
          if (video && video.duration > 0) {
            setProgress(video.currentTime / video.duration);
          }
          var anyPlaying = Array.prototype.some.call(videos, function (v) {
            return !v.paused;
          });
          if (anyPlaying) {
            rafId = requestAnimationFrame(tick);
          }
        }

        function setState(playing) {
          button.dataset.playing = playing ? '1' : '0';
          button.setAttribute('aria-pressed', playing ? 'true' : 'false');
          button.setAttribute(
            'aria-label',
            playing ? button.dataset.labelPause || 'Pause video' : button.dataset.labelPlay || 'Play video'
          );
          if (playing) {
            cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(tick);
          } else {
            cancelAnimationFrame(rafId);
          }
        }

        button.addEventListener('click', function () {
          var video = activeVideo();
          if (!video) return;
          if (video.paused) {
            videos.forEach(function (v) {
              if (v !== video) v.pause();
            });
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });

        videos.forEach(function (v) {
          v.addEventListener('play', function () {
            setState(true);
          });
          v.addEventListener('pause', function () {
            setState(false);
          });
          v.addEventListener('ended', function () {
            setState(false);
          });
        });

        var video = activeVideo();
        setState(video && !video.paused);
      });
    }

    function initAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var sections = scope.querySelectorAll('.hero-banner');
      sections.forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
